import Minimap from "./Minimap";

const Error = Minimap;

export default Error;